<template>
  <div id="app">
    <template v-if="!showNotFound">
      <div
        class="app-secret-remind"
        v-if="
          isShowRemindRoute && systemPreference && systemPreference.secretRemind
        "
      >
        {{ systemPreference.secretRemindMsg }}
      </div>
      <!--      PUGC页面无auth权限判断-->
      <template v-if="!isShowRemindRoute || authMods || isPugc">
        <router-view />
      </template>

      <!-- 加这个id="container"的div是因为如果没有登陆直接跳转到快运页面 -->
      <!--    这里先把container注释掉，添加这个以后会和portal以及openWindow中的承载微服务的container重复，
      导致直接以链接形式进入页面时，微服务被加载到该容器中，导致正常页面dom节点无数据-->
      <!--    <div id="container"></div>-->
      <!-- （module_publish_center_open）会报有饭没有碗的错误所以先把容器加上 -->
      <global-message ref="globalMessage"></global-message>
      <global-floating-cube
        ref="globalFloatingCube"
        :auths="auths"
        v-if="auths && auths.length > 0"
      ></global-floating-cube>
    </template>
    <template v-else>
      <NotFound />
    </template>
  </div>
</template>
<script>
import GlobalMessage from './components/GlobalMessageModal.vue'
import GlobalFloatingCube from './components/GlobalFloatingCube.vue'
import NotFound from '@views/NotFound/index.vue'
import { mapState } from 'vuex'
import { apps as MicroApps } from 'common-mediax/src/configs/register-micro-apps'
import RegisterAuths from '@/configs/register-auths'
import { EventBroadcastKey } from '@common/GlobalEvent'
import * as apis from '@apis'
import { createLocalPriAndPubKey } from '@common/sm2'
import customLodash from '@common/customLodash'
export default {
  name: 'App',
  components: {
    GlobalMessage,
    GlobalFloatingCube,
    NotFound
  },
  data() {
    return {
      broadcastChannel: null, // broadcast实例
      templateContainer: false,
      showNotFound: false // 是否显示404页面
    }
  },
  computed: {
    ...mapState('micro', ['systemPreference']),
    /**
     * 是否是PUGC环境
     * @returns {boolean}
     */
    isPugc() {
      return window.processEnvMode === 'PUGC'
    },
    /**
     * 判断是否显示密级提醒，登陆页面不显示
     * @returns {boolean}
     */
    isShowRemindRoute() {
      return this.$route.path.indexOf('/login') !== 0
    },
    /**
     * 用户权限列表（纯code数组）
     * @returns {*}
     */
    auths() {
      return this.$eventBus.getData(this.$eventBusDataKey.AUTH.AUTHS)
    },
    /**
     * 用户权限集合（含名称和code）
     * @returns {*}
     */
    authMods() {
      return this.$eventBus.getData(this.$eventBusDataKey.AUTH.MODS)
    },
    /**
     * SM2加密密钥
     * @returns {*}
     */
    sm2PriKey() {
      return this.$eventBus.getData(this.$eventBusDataKey.SECRET.SM2_PRI_KEY)
    },
    /**
     * SM2公钥
     **/
    sm2PubKey() {
      return this.$eventBus.getData(this.$eventBusDataKey.SECRET.SM2_PUB_KEY)
    },
    /**
     * SM4密钥
     **/
    sm4PriKey() {
      return this.$eventBus.getData(this.$eventBusDataKey.SECRET.SM4_PRI_KEY)
    }
  },
  watch: {
    sm2PriKey: {
      handler(val) {
        this.broadcastChannel.postMessage({
          type: EventBroadcastKey.UPDATE_SECRET_DATA,
          data: {
            key: this.$eventBusDataKey.SECRET.SM2_PRI_KEY,
            val
          }
        })
      }
    },
    sm2PubKey: {
      handler(val) {
        this.broadcastChannel.postMessage({
          type: EventBroadcastKey.UPDATE_SECRET_DATA,
          data: {
            key: this.$eventBusDataKey.SECRET.SM2_PUB_KEY,
            val
          }
        })
      }
    },
    sm4PriKey: {
      handler(val) {
        this.broadcastChannel.postMessage({
          type: EventBroadcastKey.UPDATE_SECRET_DATA,
          data: {
            key: this.$eventBusDataKey.SECRET.SM4_PRI_KEY,
            val
          }
        })
      }
    },
    $route: {
      handler: async function (val, oldVal) {
        if (!val) {
          // 处理 $route 为空的情况
          return
        }
        // 登录页和域名首页等未登录页面不需要获取权限
        if (
          val.name &&
          val.name !== 'Login' &&
          !this.auths &&
          (!oldVal || (oldVal && ['Login', null].includes(oldVal.name)))
        ) {
          await this.getPortals()
        }
        if (
          val.name &&
          val.name !== 'Login' &&
          this.auths &&
          (!oldVal || (oldVal && ['Login', null].includes(oldVal.name)))
        ) {
          let userInfo = localStorage.getItem('loginInfo')
          userInfo = JSON.parse(userInfo)
          await createLocalPriAndPubKey(userInfo.userCode)
        }
        let path = val.path
        // 针对新开页面或service页面，判断微服务是否存在
        if (path.indexOf('/open/') > -1 || path.indexOf('/service/') > -1) {
          // 获取微服务名称
          path = path.split('/').filter((item) => item !== '')
          let hasRoute = path[1] ? false : true
          path = `/${path[0]}/${path[1]}`
          // 判断微服务的activeRoute是否和当前路径匹配
          MicroApps.forEach((item) => {
            if (item.activeRule === path) {
              hasRoute = true
            }
          })
          if (!hasRoute) {
            this.showNotFound = true
          }
        }
        if (
          (!oldVal || oldVal.name === null) &&
          val &&
          val.name !== 'Login' &&
          val.name
        ) {
          if (process.env.MODE !== 'PUGC') {
            // 异步加载，不阻塞页面渲染,只在刷新页面时才执行
            this.getMainUserPreference()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 显示404页面
     */
    showNotFoundPage() {
      this.showNotFound = true
    },
    /**
     * 获取用户个性化信息，此处主要为了获取运营智能助手开关，后续如果有需要刷新个用户数据信息，可在此方法中添加
     * @returns {Promise<void>}
     */
    async getMainUserPreference() {
      let res = await apis.MediaCloudGateway.getMainUserPreference()
      if (res.data.status === 0) {
        // 配置运营智能助手开关
        this.$eventBus.setData(
          this.$eventBusDataKey.AUTH.AI_ASSISTANT_SWITCH,
          res.data.data.aiAssistantSwitch
        )
      }
    },
    /**
     * 获取用户权限信息
     * @returns {Promise<void>}
     */
    async getPortals() {
      if (process.env.MODE !== 'PUGC') {
        let authObj = new RegisterAuths()
        await authObj.getAuths()
      }
    },
    /**
     * 监听 'newMessage' 事件，当有新消息时显示弹框
     * @param {Object} event 事件对象
     */
    handleNewMessage(event) {
      this.$refs.globalMessage.show(event.detail)
    },
    updateSm2PubKey(val) {
      this.$eventBus.setData(this.$eventBusDataKey.SECRET.SM2_PUB_KEY, val)
    },
    updateSm2PriKey(val) {
      this.$eventBus.setData(this.$eventBusDataKey.SECRET.SM2_PRI_KEY, val)
    },
    updateSm4PriKey(val) {
      this.$eventBus.setData(this.$eventBusDataKey.SECRET.SM4_PRI_KEY, val)
    }
  },
  mounted() {
    // 监听 'newMessage' 事件，当有新消息时显示弹框
    window.addEventListener('newMessage', this.handleNewMessage)
    this.$eventBus.$on(this.$globalEvent.LINK_NOT_FOUND, this.showNotFoundPage)
    // 创建广播频道
    this.broadcastChannel = new BroadcastChannel(
      EventBroadcastKey.UPDATE_SECRET_DATA
    )
    let debouncPubLinster = customLodash.debounce(this.updateSm2PubKey, 500)
    let debouncPriLinster = customLodash.debounce(this.updateSm2PriKey, 500)
    let debouncSm4PriLinster = customLodash.debounce(this.updateSm4PriKey, 500)
    // 监听广播消息
    this.broadcastChannel.onmessage = (event) => {
      // 如果是更新密钥数据，则更新密钥数据

      if (event.data.type === EventBroadcastKey.UPDATE_SECRET_DATA) {
        if (event.data.data.key === this.$eventBusDataKey.SECRET.SM2_PUB_KEY) {
          debouncPubLinster(event.data.data.val)
        }
        if (event.data.data.key === this.$eventBusDataKey.SECRET.SM2_PRI_KEY) {
          debouncPriLinster(event.data.data.val)
        }
        if (event.data.data.key === this.$eventBusDataKey.SECRET.SM4_PRI_KEY) {
          debouncSm4PriLinster(event.data.data.val)
        }
      }
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    this.$eventBus.$off(this.$globalEvent.LINK_NOT_FOUND, this.showNotFoundPage)
    this.broadcastChannel.close()
    // 移除事件监听器，防止内存泄漏
    window.removeEventListener('newMessage', this.handleNewMessage)
  }
}
</script>
<style lang="scss">
html,
body {
  height: 100%;
  overflow: hidden;
  // min-width: 1200px;
}
#app {
  height: 100%;
  #container {
    // 内容快运的盒子导致 新建稿件页面未填写必填项时，未填项显示在顶部，页面整体向上移动了，底部出现空白， 先注掉，后续更改
    // height: 100%;
  }
  .app-secret-remind {
    color: #ff0000;
    font-size: 12px;
    text-align: center;
    padding: 3px 0;
    background: #fffbe7;
    & + .portal,
    & + #container,
    & + .new-window {
      height: calc(100% - 20px);
    }
  }
}
</style>
